export enum StorageType {
  Local = 'local',
  Session = 'session',
  Worker = 'worker',
}

export default StorageType;
